import * as yup from 'yup';

export const validateRowSchema = yup.object().shape({
    postcode: yup
        .number()
        .typeError("Only number")
        .required('Required')
})


export const validationSchema = yup.object({
    areaName: yup
        .string()
        .required('Required'),
    rows: yup.array().of(validateRowSchema)
})

export const initialRowValues = {
    postcode: "",
}

export const initialValues = {
    areaName: "",
    status: true,
    rows: [initialRowValues],
}
